/* eslint-disable @typescript-eslint/naming-convention */

import {
  track,
  createScreenViewedEvent,
  createSubmittedEvent,
  createErrorEvent,
} from "./base"

export const signInViewed = () => {
  track(createScreenViewedEvent({ current_screen: "Sign In" }))
}

export const googleSignInSubmitted = ({ email }: { email: string }) => {
  track(
    createSubmittedEvent({
      object_name: "Sign In",
      current_screen: "Sign In",
      to_screen: "Ext:Google Auth Screens",
      component_type: "google_auth_button",
      component_text: "Sign In with Google",
      submitted_values: {
        email,
      },
    })
  )
}

export const googleSignInFailed = ({
  message,
  error_code,
}: {
  message: string
  error_code?: string
}) => {
  track(
    createErrorEvent({
      event_name: "Google Sign-In Failed",
      message: `${message}${error_code ? ` (Code: ${error_code})` : ""}`,
    })
  )
}

export const appleSignInSubmitted = ({ email }: { email: string }) => {
  track(
    createSubmittedEvent({
      object_name: "Sign In",
      current_screen: "Sign In",
      to_screen: "Ext:Apple Auth Screens",
      component_type: "apple_auth_button",
      component_text: "Sign In with Apple",
      submitted_values: {
        email,
      },
    })
  )
}

export const emailSignInSubmitted = ({ email }: { email: string }) => {
  track(
    createSubmittedEvent({
      object_name: "Sign In",
      current_screen: "Sign In",
      to_screen: "Home",
      component_type: "button",
      component_text: "Sign In",
      submitted_values: {
        email,
      },
    })
  )
}
